class salesChannelRegister {

    static data = {
        logo: null,
        logo_dashboard: null,
        logo_mobile: null,
        saleschannel: null,
        email: null,
        market: null,
        socialIcon: null,
        socialTitle: null,
        facebookId: null,
        company_name: null,
        instagramId: null,
        ga_id: null,
        ga4_id: null,
        currency: null,
        vat: null,
        channels: null,
        languages: null,
        country_region: null,
        default_language: null,
        durations: null,
        default_duration: null,
        private: null,

        meta_title: null,
        meta_description: null,
        og_image: null,
        canonical: null,

        favicon_apple: null,
        favicon_32: null,
        favicon_16: null,
        favicon_manifest: null,
        favicon_safari: null,

        signup_home_mission_desktop_en: null,
        signup_home_mission_mobile_1_en: null,
        signup_home_mission_mobile_2_en: null,
        signup_home_mission_desktop_sv: null,
        signup_home_mission_mobile_1_sv: null,
        signup_home_mission_mobile_2_sv: null,

        signup_home_item_10_en: null,
        signup_home_item_12_en: null,
        signup_home_item_13_en: null,
        signup_home_item_14_en: null,
        signup_home_item_15_en: null,
        signup_home_item_16_en: null,
        signup_home_item_17_en: null,
        signup_home_item_18_en: null,
        industry_search_item_1_en: null,

        signup_home_item_10_sv: null,
        signup_home_item_12_sv: null,
        signup_home_item_13_sv: null,
        signup_home_item_14_sv: null,
        signup_home_item_15_sv: null,
        signup_home_item_16_sv: null,
        signup_home_item_17_sv: null,
        signup_home_item_18_sv: null,
        industry_search_item_1_sv: null,
    };

    static set(type, value) {
        try {
            salesChannelRegister.data[type] = value;
            sessionStorage.setItem('saleschannel-' + type, value);
        } catch (e) {
            salesChannelRegister.data[type] = value;
        }
    }

    static get(type) {
        try {
            if (salesChannelRegister.data[type]) {
                return salesChannelRegister.data[type];
            } else {
                return sessionStorage.getItem('saleschannel-' + type);
            }
        } catch (e) {
            return salesChannelRegister[type];
        }
    }

    static remove(type) {
        if (salesChannelRegister.data[type]) {
            salesChannelRegister.data[type] = null;
        }
        try {
            sessionStorage.removeItem('saleschannel-' + type);
        } catch (e) {}
    }
}

export {salesChannelRegister}


// WEBPACK FOOTER //
// ./src/services/salesChannelRegister.js